// extracted by mini-css-extract-plugin
export default {"notification_modal":"notification-modal_notification_modal__RvBEw","card":"notification-modal_card__tcAgU","card_shadow":"notification-modal_card_shadow__6UXr6"};